import * as types from "./consultarProtocolo.actionTypes";

export default {
  setTokenRecaptcha: data => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data
  }),
  setTokenRecaptchaModal: data => ({
    type: types.SET_TOKEN_RECAPTCHA_MODAL,
    payload: data
  }),
  pesquisarConsultarProtocolo: data => ({
    type: types.PESQUISAR_CONSULTAR_PROTOCOLO,
    payload: data
  }),
  toggleModalConsultarProtocolo: () => ({
    type: types.TOGGLE_MODAL_CONSULTAR_PROTOCOLO
  }),
  setGridConsultarProtocolo: data => ({
    type: types.SET_GRID_CONSULTAR_PROTOCOLO,
    payload: data
  }),
  pesquisarConsultarProtocoloModal: data => ({
    type: types.PESQUISAR_CONSULTAR_PROTOCOLO_MODAL,
    payload: data
  }),
  abrirConsultarProtocolo: data => ({
    type: types.ABRIR_CONSULTAR_PROTOCOLO,
    payload: data
  }),
  setConsultarProtocoloGridPesquisa: data => ({
    type: types.SET_GRID_PESQUISA_CONSULTAR_PROTOCOLO,
    payload: data
  }),
  setHeaderConsultarProtocolo: data => ({
    type: types.SET_HEADER_CONSULTAR_PROTOCOLO,
    payload: data
  }),
  viewAnalise: data => ({
    type: types.VIEW_ANALISE_CONSULTAR_PROTOCOLO,
    payload: data
  }),
  toggleModalViewAnalise: () => ({
    type: types.TOOGLE_MODAL_VIEW_ANALISE
  }),
  setViewAnalise: data => ({
    type: types.SET_VIEW_ANALISE,
    payload: data
  }),
  modalViewAnalise: () => ({
    type: types.MODAL_VIEW_ANALISE
  }),
  limpaGridsConsultarProtocolo: () => ({
    type: types.LIMPA_GRIDS_CONSULTAR_PROTOCOLO
  }),
  setRecaptchaResetRef: data => ({
    type: types.SET_RECAPTCHA_RESET_REF,
    payload: data
  }),
  setRecaptchaResetRefModal: data => ({
    type: types.SET_RECAPTCHA_RESET_REF_MODAL,
    payload: data
  }),
};
